/**
 * @generated SignedSource<<cd37e848996576d7d65fb69551311e03>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventDetails_participativeModule",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "visualization",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startsAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endsAt",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "alreadySubmitted",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "remainingSeats",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "maximumSeats",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "EventAuthorizations",
              "kind": "LinkedField",
              "name": "authorizations",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayMaximumSeats",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayRemainingSeats",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "EventMap_event"
            }
          ],
          "type": "EventVisualization",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ParticipativeModuleAuthorizations",
      "kind": "LinkedField",
      "name": "authorizations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contributionsSubmissionAuthorized",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TitleBarWithAction_resource"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SubscribeToEventButton_participativeModule"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EventCalendarDropdownButton_participativeModule"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PageSections_page"
    }
  ],
  "type": "Event",
  "abstractKey": null
};

node.hash = "a75609a0f79d262f85c03a47e78d34e1";

module.exports = node;
